import HttpService from '@/utils/httpService';

class CorrosionAnalyserService {
  /**
   * Get corrosion analyser entries with pagination and filters
   */
  get(params) {
    return HttpService.post({
      url: 'api/tags/ava-inspect/TypeHead',
      data: params,
    });
  }

  /**
   * Get available filter options for corrosion analyser
   */
  getFilters(payload) {
    return HttpService.get({
      url: 'api/tags/ava-inspect/filters',
      params: payload,
    });
  }

  /**
   * Get corrosion analyser entry by ID
   */
  getById(id) {
    return HttpService.get({
      url: `api/tags/ava-inspect/${id}`,
    });
  }

  /**
   * Update corrosion analyser entry
   */
  update(id, data) {
    return HttpService.put({
      url: `api/tags/ava-inspect/${id}`,
      data,
    });
  }

  /**
   * Delete corrosion analyser entries
   */
  delete(ids) {
    return HttpService.post({
      url: 'api/tags/ava-inspect/deleteAvaInspect',
      data: { ids },
    });
  }
}

export default new CorrosionAnalyserService();
